const EventNames = {
  PAYMENT_PAGE_OPENED: 'Payment_Page_Opened',
  PAYMENT_GATEWAY_OPENED: 'Payment_Gateway_Opened',
};

export default EventNames;
